import { Icon } from '@/components'
import { Stack, StackProps, SvgIconProps, Typography, TypographyProps } from '@mui/material'
import parser from 'html-react-parser'
import { TContentProductCommitment } from '../../types'

type ProductFeaturesProps = {
  list: TContentProductCommitment[] | undefined
  props?: Omit<StackProps, 'children'>
  itemProps?: Omit<StackProps, 'children'>
  iconProps?: Omit<SvgIconProps, 'children'>
  textProps?: Omit<TypographyProps, 'children'>
}
export const ProductFeatures = ({ list, props, itemProps, iconProps, textProps }: ProductFeaturesProps) => {
  return (
    <Stack flexWrap="wrap" gap={2} sx={{ width: '100%' }} {...props}>
      {list?.map((feature, index) => (
        <Stack
          key={index}
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ fontSize: { xs: '1rem', lg: '1.25rem' } }}
          {...itemProps}
        >
          <Icon.CheckCircle
            color="primary"
            sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
            {...iconProps}
          />
          <Typography sx={{ fontSize: 'inherit', fontWeight: 600 }} {...textProps}>
            {parser(feature?.label || '')}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}
